import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { productApi } from './services/features/productApi/productApi';
import { clientApi } from './services/features/clientApi/clientApi';
import { quoteApi } from './services/features/quoteApi/quoteApi';
import errorSlice from './services/features/errorSlice/errorSlice';
import quoteSlice from './services/features/quoteSlice/quoteSlice';
import authSlice from './services/features/authApi/authSlice';
import dialogSlice from './services/features/dialogSlice/dialogSlice';
import { documentsApi } from './services/features/documentsApi/documentsApi';
import { brokerApi } from './services/features/brokerApi/brokerApi';
import { authApi } from './services/features/authApi/authApi';

const store = configureStore({
	reducer: {
		errorSlice,
		quoteSlice,
		dialogSlice,
		authSlice,
		[productApi.reducerPath]: productApi.reducer,
		[clientApi.reducerPath]: clientApi.reducer,
		[quoteApi.reducerPath]: quoteApi.reducer,
		[documentsApi.reducerPath]: documentsApi.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[brokerApi.reducerPath]: brokerApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			productApi.middleware,
			clientApi.middleware,
			quoteApi.middleware,
			documentsApi.middleware,
			authApi.middleware,
			brokerApi.middleware
		),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
